export default __webpack_public_path__ + "static/media/shopping-cart.623a16ed.svg";